const verhoeffTableD = [
  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
  [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
  [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
  [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
  [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
  [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
  [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
  [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
  [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]
];

const verhoeffTableP = [
  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
  [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
  [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
  [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
  [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
  [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
  [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]
];

export const isAadhaarFormatValid = (value) => /^\d{12}$/.test((value || '').trim());

export const validateAadhaarVerhoeff = (value) => {
  const aadhaar = (value || '').trim();
  if (!isAadhaarFormatValid(aadhaar)) {
    return false;
  }

  let checksum = 0;
  const digits = aadhaar.split('').reverse().map(Number);
  digits.forEach((digit, index) => {
    checksum = verhoeffTableD[checksum][verhoeffTableP[index % 8][digit]];
  });

  return checksum === 0;
};

export const isAadhaarValid = (value, options = {}) => {
  const { skipChecksum = false } = options;
  if (!value || value.trim() === '') {
    return true; // Consider empty value as valid (optional, based on your requirements)
  }
  if (!isAadhaarFormatValid(value)) {
    return false;
  }
  return skipChecksum ? true : validateAadhaarVerhoeff(value);
};
